import React, { useState, useEffect, useRef } from "react";
import Logo from "./navbar/logo";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSignUpLink, getSignInLink } from "../../utils/path-helper";
import "./navbar/btns-group.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const RBHeader = ({ isLogoDisabled }) => {
  const navigate = useNavigate();
  const { locale } = useParams();
  const { t } = useTranslation();

  const signInLink = getSignInLink(locale, "");
  const signUpLink = getSignUpLink(locale, "");

  const [noBoxShadow, setNoBoxShadow] = useState(true);
  const dropdownRef = useRef(null);

  const handleClickOutsideBoxShadow = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setNoBoxShadow(true);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideBoxShadow);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideBoxShadow);
    };
  }, []);

  const handleToggleMenuBarClick = () => setNoBoxShadow(!noBoxShadow);
  const handleSignInClick = () => navigate(signInLink);
  const handleSignUpClick = () => navigate(signUpLink);

  let localeval = "";
  if (!!locale) {
    localeval = locale;
  }
  const isSignInPage = ["signin"].includes(
    window.location.pathname.split("/").pop()
  );

  return (
    <header className="header py-2">
      <nav className="border-b mx-auto px-4 md:mx-4 lg:mx-36">
        <div className="flex justify-between align-middle">
          <Logo disabled={isLogoDisabled} />
          <div id="navbarNavAltMarkup" className="show">
            <div
              ref={dropdownRef}
              className={`sign-menu navbar-menu hide-arrow ${
                noBoxShadow ? "no-box-shadow" : ""
              }`}
            >
              <button
                aria-hidden="true"
                id="my_account"
                className="btn btn-outline-primary navbar-btn"
                onClick={handleToggleMenuBarClick}
              >
                <span className="bars-hidden-cls">
                  <FontAwesomeIcon icon={faBars} aria-hidden="true" />
                </span>
                <span
                  className="dropdown-btn-hide hover:bg-[#fe8c26] transition-all duration-400 ease-out delay-100 active:bg-blue-500 hover:text-white text-sm !py-1 !px-2"
                  onClick={isSignInPage ? handleSignUpClick : handleSignInClick}
                >
                  {isSignInPage ? t("sign_up.btn_cta") : t("sign_up.sign_in")}
                </span>
              </button>

              <div
                className={`dropdown-menu ${
                  noBoxShadow ? "no-box-shadow" : ""
                }`}
              >
                <button
                  aria-hidden="true"
                  className="btn btn-link btn-cross inline-block"
                  onClick={handleToggleMenuBarClick}
                >
                  <FontAwesomeIcon
                    icon={faTimes}
                    aria-hidden="true"
                    className="text-green-500"
                  />
                </button>
                <button
                  className="dropdown-item text-sm text-left  w-full "
                  onClick={isSignInPage ? handleSignUpClick : handleSignInClick}
                >
                  {isSignInPage ? t("sign_up.btn_cta") : t("sign_up.sign_in")}
                </button>
                <hr className="divider" />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default RBHeader;
